import {createSelector} from '@reduxjs/toolkit'

const nsLoginSelector = createSelector(
    [state => state.components],
    ({nsLogin}) => {
        return nsLogin
    }
)

export const nsLoginSelect = state => ({
    nsLogin: nsLoginSelector(state)
})